import firebase from "firebase/app";
import { useState, useEffect } from "react";

import "../firebase";
import allowedEmails from "../allowedEmails.json";

export default function useLoginStatus() {
  const [isLoggedIn, setIsLoggedIn] = useState(null);

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      if (user != null && allowedEmails[user.email]) {
        setIsLoggedIn(true);
      } else if (user != null) {
        setIsLoggedIn(false);
      } else {
        setIsLoggedIn(null);
      }
    });
    return () => unsubscribe();
  }, []);

  return isLoggedIn;
}
